<template>
  <v-row >
    <v-col>
      <v-row no-gutters class="mb-2">
        <v-col>
            <h4>{{ counterName }}</h4>
          </v-col>
      </v-row>
      <v-row  no-gutters>
        <v-col>
          <v-row no-gutters align="center">
            <v-col>
              <b>{{ $t('servicesystem.common_objects.counter.date') }}</b>
            </v-col>
            <v-col>
              <b>{{ $t('servicesystem.common_objects.counter.value') }}</b> 
            </v-col>
          </v-row>
          <v-row no-gutters align="center" style="border-bottom: 1px solid #e0e0e0;">
            <v-col>
              {{ $t('servicesystem.common_objects.commonterms.today') }}
            </v-col>
            <v-col>
              <v-text-field v-model="todayValue.editValue"  :loading="todayValue.loading" clearable hide-details="auto"
                :error="todayValue.errors && todayValue.errors.length > 0" :error-messages="todayValue.errors" 
                class="pt-0 mt-0" @blur="setCounter(todayValue)"> 
              </v-text-field>
            </v-col>
          </v-row>
          <v-hover v-slot="{ hover }" v-for="(value, index) in valueList.filter(x => !x.IsToday)" :key="index" >
            <v-row align="center" no-gutters style="border-bottom: 1px solid #e0e0e0; height: 30px;">
              <v-col>
                {{ i18nFormatDate(value.Date) }}
              </v-col>
              <v-col>
                <v-row no-gutters align="center">
                  <v-col cols="0">
                    {{ value.Value }}
                  </v-col>
                  <v-col cols="auto" v-if="hover">
                    <v-btn icon small>
                      <v-icon size="18" @click="deleteMachineCounter(value)">mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-hover>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import Vue from "vue";
//import MachineSelect from "@/components/MachineSelect2.vue";

export default {
  name: "MachineCounterDialog",
  model: {
    prop: "values",
    event: "update",
  },
  props: {
    counterName: String,
    counterId: Number,
    machineId: [Number, String],
    values: Array,
  },
  components: {},
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  methods: { 
    async setCounter(counter) {
      if (counter.Value === counter.editValue) {
        return;
      }
      else {
        counter.Value = counter.editValue;
        console.log('counter', counter)
         Vue.set(counter, 'loading', true);
        await this.setMachineCounter(counter)
          .then(() => {
            counter.errors = null;
          })
          .catch((error) => {
            if (error.status != 204) {
              console.error(error);
              counter.errors = 'Error saving value.';
            }
          })
          .finally(() => {
            Vue.set(counter, 'loading', false);
          });
      }
    },

    async deleteMachineCounter(counter) {
      Vue.set(counter, 'loading', true);
      await this.deleteHistoricMachineCounter(counter)
        .then(() => {
          this.valueList = this.valueList.filter(x => x.Date !== counter.Date);
        })
        .catch((error) => {
          console.error(error);
          counter.errors = 'Error deleting value.';
        })
        .finally(() => {
          Vue.set(counter, 'loading', false);
        });
    },
  },

  computed: { 
    todayValue() {
      var val =
        this.values.find(x => x.IsToday) ??
        { CounterId: this.counterId, MachineId: this.machineId, Value: '', Date: new Date(), IsToday: true };
      var obj = {...val, editValue: val.Value, loading: false, errors: null };
      return obj;
    },

    valueList: {
      get() {
        return this.values;
      },
      set(value) {
        this.$emit("update", value);
      }
    },
  },

  watch: {  },
};
</script>